import {toast} from 'react-toastify';

export const showComingSoonToast = () => {
    toast.info('Coming Soon! That feature is not supported yet.');
};
